<template>
  <div id="IndentTree" class="indent_tree" @click="$emit('previewAllImages')" />
</template>
<script>
import G6 from 'antvG6'
import { mergeImagesByCanvas } from '../../handler.js'
import { createTree } from './tree'
export default {
  props: {
    scene: Number,
    resultData: {
      type: Object,
      default: () => ({})
    },
    liabilityShowType: Number,
    isShowBusinessCard: Boolean,
    cardImageData: String
  },
  data () {
    return {
      tree: null,
      cacheImageDataUrl: {},
      maxHeight: 10000 // 浏览器限制了 canvas 大小，高度超出一定范围，超出部分不会渲染（空白）。浏览器限制不一，10000 是调试后的一个可行值，可改（需谨慎）。
    }
  },
  computed: {
    isShowInPc () {
      return [5, 6].includes(this.scene)
    },
    dataURLName () {
      return `${this.isShowBusinessCard ? 'card' : 'nocard'}`
    },
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      const self = this
      self.tree = createTree(G6, {
        resultData: self.resultData,
        liabilityShowType: self.liabilityShowType,
        afterlayout (g) {
          self.svg2Base64(g)
        }
      })
    },
    svg2Base64 (graph) {
      const self = this
      const { maxHeight, isShowInPc } = self
      const svgGDom = document.querySelector('#IndentTree svg g')
      if (svgGDom) {
        const { width, height } = svgGDom.getBBox()
        const ratio = isShowInPc ? graph.getZoom() : (window.innerWidth / width).toFixed(1) * 2
        const padding = 20 * window.devicePixelRatio
        let canvasWidth = width * ratio
        let canvasHeight = height * ratio
        if (canvasHeight > maxHeight) {
          canvasWidth = canvasWidth * (maxHeight / canvasHeight)
          canvasHeight = maxHeight
          self.zoomChart(graph, maxHeight / canvasHeight, {width})
        } else {
          self.zoomChart(graph, 1, {width})
        }
        return new Promise(resolve => {
          graph.toFullDataURL((dataURL) => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.width = canvasWidth + padding
            canvas.height = canvasHeight + padding
            const image = new Image()
            image.onload = () => {
              ctx.fillStyle = '#ffffff'
              ctx.fillRect(0, 0, canvasWidth + padding, canvasHeight + padding)
              ctx.drawImage(image, padding / 2, padding / 2, canvasWidth, canvasHeight)
              self.zoomChart(graph)
              resolve(canvas.toDataURL())
            }
            image.onerror = () => {
              resolve(null)
            }
            image.src = dataURL
          }, null)
        })
      }
    },
    zoomChart (graph, toRatio, options = {}) {
      if (this.isShowInPc) {
        return
      }
      const { width = 357 } = options
      if (toRatio) {
        graph.zoomTo(toRatio)
        graph.moveTo((357 - width) / 2, 0)
        return
      }
      graph.fitView()
      graph.fitCenter()
    },
    async generateImage (isShowLoading = true) {
      const { isShowBusinessCard, cardImageData, cacheImageDataUrl, tree, dataURLName } = this
      if (!cacheImageDataUrl[dataURLName]) {
        if (isShowLoading) {
          appBridge.showLoading()
        }
        const dataURL = await this.svg2Base64(tree)
        cacheImageDataUrl[dataURLName] = await mergeImagesByCanvas([dataURL, isShowBusinessCard ? cardImageData : ''].filter(e => !!e))
        if (isShowLoading) {
          appBridge.hideLoading()
        }
      }
      return cacheImageDataUrl[dataURLName]
    }
  }
}
</script>
<style lang="postcss" scoped>
.indent_tree {
  height: 100%;
  max-width: 1500px;
  margin: 0 auto;
  overflow: hidden;
}
</style>